import { DateString, daysBetween, isValidDateString } from './date_string.ts';

export const trialLengthInDays = 7;

export type TrialState = { status: 'pre-trial' } | { status: 'active'; daysLeft: number } | { status: 'expired' };

export function deriveTrialState({
  trialStartDate,
  clientDate,
}: {
  trialStartDate?: DateString;
  clientDate: DateString;
}): TrialState {
  if (!trialStartDate) {
    return { status: 'pre-trial' };
  }
  if (!isValidDateString(trialStartDate) || !isValidDateString(clientDate)) {
    throw new Error(`Invalid trial date: ${trialStartDate}, ${clientDate}`);
  }

  const daysElapsed = daysBetween(trialStartDate, clientDate);
  if (daysElapsed < 0) {
    return { status: 'pre-trial' };
  }
  if (daysElapsed < trialLengthInDays) {
    return { status: 'active', daysLeft: trialLengthInDays - daysElapsed };
  }
  return { status: 'expired' };
}
